import { AxiosResponse } from 'axios';
import { jobBoardAPI } from './base';

export const rigEndpoints = {
  getAllRigs: '/rig',
  create: '/rig',
  update: '/rig/:{id}',
  search: '/rig/search'
};

export interface RigResponse {
  _id: string;
  name: string;
  location: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface RigDTO {
  name: string;
  description: string;
}

export const GET_RIGS_QUERY = async (): Promise<
  AxiosResponse<RigResponse[]>
> => {
  const { data } = await jobBoardAPI.get(rigEndpoints.getAllRigs);
  return data;
};

export const CREATE_RIG = async (
  data: RigDTO
): Promise<AxiosResponse<RigResponse>> =>
  jobBoardAPI.post(rigEndpoints.create, data);

export const DELETE_RIG = async (
  rigId: string
): Promise<AxiosResponse<void>> => {
  const endpoint = `/rig/${rigId}`;
  return jobBoardAPI.delete(endpoint);
};

export const UPDATE_RIG = async ({
  rigId,
  data
}: {
  rigId: string;
  data: RigDTO;
}): Promise<AxiosResponse<RigResponse>> =>
  jobBoardAPI.patch(rigEndpoints.update.replace(':{id}', rigId), data);

export const SEARCH_RIGS = async (
  query: string
): Promise<AxiosResponse<RigResponse[]>> => {
  const response = await jobBoardAPI.get(`${rigEndpoints.search}?q=${query}`);
  return response.data;
};
